<template>
	<div class="main" v-loading.fullscreen="isLoad" element-loading-background="rgba(0, 0, 0,0)">
		<el-breadcrumb  separator-class="el-icon-arrow-right">
			<el-breadcrumb-item><div style="display: inline-block;" @click="gotopage('/Basics/Gold.html')">店铺管理</div></el-breadcrumb-item>
			<el-breadcrumb-item>店铺管理</el-breadcrumb-item>
		</el-breadcrumb>

		<el-form :inline="true" :model="item" class="search">
			<el-form-item label="店铺名称">
				<el-input v-model="item.name" placeholder="请输入店铺名称" size="small"></el-input>
			</el-form-item>
			<!-- <el-form-item label="所属商家">
                <el-select v-model="item.businessId" @change="changeBusinessId"  clearable placeholder="请选择" size="small">
                    <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.businessName"
                            :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="所属店铺">
                <el-select v-model="item.name" clearable placeholder="请先选择所属商家" size="small">
                    <el-option
                            v-for="item in optionsShop"
                            :key="item.value"
                            :label="item.name"
                            :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item> -->

			<el-form-item label="手机号码">
				<el-input v-model="item.mobile" placeholder="请输入手机号码" size="small"></el-input>
			</el-form-item>
			<el-form-item label="店铺等级">
				<el-select v-model="item.storeRankId" clearable placeholder="请选择" size="small">
					<el-option v-for="item in optionsLevel" :key="item.value" :label="item.name" :value="item.id">
					</el-option>
				</el-select>
			</el-form-item>

			<el-form-item>
				<el-button type="primary" @click="submit" size="medium">查询</el-button>
<!--				<el-button type="success" @click="excelOut" size="medium">导出-->
<!--				</el-button>-->
			</el-form-item>
		</el-form>

		<div class="btns">
			<el-button type="primary" size="small" @click="add" v-auth="['admin/business.store/add']">添加店铺</el-button>
			<el-button type="danger" size="small" @click="delAll" v-auth="['admin/business.store/delete']">批量冻结</el-button>
		</div>

		<!--		数据是list 通过list展示-->
		<el-table :data="list" border @selection-change="handleSelectionChange">
			<el-table-column type="selection" align="center"></el-table-column>
			<el-table-column width="60" align="center">
				<template slot-scope="scope">
					{{scope.$index + (page-1) * pageSize + 1}}
				</template>
			</el-table-column>
			<el-table-column prop="name" label="店铺名称"></el-table-column>
			<el-table-column prop="address" label="所属区域"></el-table-column>
			<el-table-column prop="mobile" label="手机号码"></el-table-column>
			<el-table-column prop="front_fee" label="预存款"></el-table-column>
			<el-table-column prop="credit_fee" label="授信额度"></el-table-column>
			<el-table-column prop="freeze_credit_fee" label="已使用额度"></el-table-column>
			<el-table-column  label="店铺等级" align="center">
				<template slot-scope="scope">
					<div style="display: flex; align-items: center;" v-if="scope.row.rank">
						{{scope.row.rank.name}}
					</div>
				</template>
			</el-table-column>
			<el-table-column label="状态" align="center">
				<!--			价格模板插槽	-->
				<template slot-scope="scope">
					<el-tag size="small" type="success" v-if="scope.row.is_enabled">
						激活
					</el-tag>
					<el-tag size="small" type="danger" v-else>
						冻结
					</el-tag>
				</template>
			</el-table-column>
			<el-table-column prop="created_date" label="注册日期" width="180"></el-table-column>
			<el-table-column label="操作" width="360">
				<template slot-scope="scope">
<!--					<el-button size="mini" type="primary" @click="edit(scope.row.id)">预存款</el-button>-->
<!--					<el-button size="mini" type="primary" @click="edit(scope.row.id)">授信</el-button>-->
<!--					<el-button size="mini" type="primary">初始化</el-button>-->
					<el-button size="mini" type="primary" @click="edit(scope.row.id)" v-auth="['admin/business.store/update']">编辑</el-button>
					<el-popconfirm title="您确定要冻结这条数据吗？" @confirm="del(scope.row.id)" class="l10" v-if="scope.row.is_enabled == 1" v-auth="['admin/business.store/delete']">
						<el-button size="mini" type="danger" slot="reference">冻结</el-button>
					</el-popconfirm>
					<el-popconfirm title="您确定要解冻这条数据吗？" @confirm="jiedong(scope.row.id)" class="l10" v-auth="['admin/business.store/jiedong']" v-else>
						<el-button size="mini" type="danger" slot="reference">解冻</el-button>
					</el-popconfirm>
<!--					<el-popconfirm title="您确定要冻结这条数据吗？" @confirm="del(scope.row.id)" class="l10">-->
<!--						<el-button size="mini" type="danger" slot="reference">冻结</el-button>-->
<!--					</el-popconfirm>-->
				</template>
			</el-table-column>
		</el-table>
		<el-pagination @size-change="sizeReload" @current-change="pageReload" :current-page="page"
			:current-page.sync="pageNum" :page-sizes="[20, 100, 200, 300, 400]" :page-size="pageSize"
			layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
	</div>
</template>
<script>
	export default {
		name: 'index',
		data() {
			return {
				list: [],
				isLoad: false,
				pageNum: 0,
				pageSize: 20,
				total: 0,
				page: 1,
				// 查询
				item: {},
				options: [],
				optionsLevel: [],
				optionsShop: []
			}
		},
		created() {
			this.item = {
				page: this.page,
				limit: this.pageSize
			}
			this.loadList()
		},
		methods: {
			gotopage(url){
				var link =  this.$router.resolve({
					path: url
				});
				window.open(link.href, '_blank')
			},
			// changeBusinessId() {
			//     this.item.name = ''
			//     this.optionsShop = []
			//     this.axios.post('/api/common/getStoreListByBusinessId', {
			//         id: this.item.businessId
			//     }).then(res => {
			//         res.data.forEach((item) => {
			//             this.optionsShop.push(item)
			//         })
			//     }).catch(() => {
			//         this.isLoad = !this.isLoad
			//     })
			// },
			async loadList() {
				if (this.isLoad)
					return
				this.isLoad = !this.isLoad
				let res = ""

				res = await this.axios.post('/admin/business/list', {
					page: this.page,
					limit: this.pageSizeNume
				})
				this.options = res.data.records

				res = await this.axios.post('/admin/data/listStoreRankForSelect', {})
				this.optionsLevel = res.data.list

				res = await this.axios.post('/admin/business.store/list', this.item)

				// 获取数据
				this.list = res.data.list.data
				// 页数 page
				this.total = res.data.list.total
				this.isLoad = !this.isLoad
			},
			// 跳转到edit添加
			add() {
				this.$router.push({
					path: '/Shop/edit.html'
				});
			},
			// 传一个ID跳转到edit页面，进行编辑
			edit(id) {
				this.$router.push({
					path: '/Shop/edit.html',
					query: {
						id: id
					}
				});
			},
			//
			del(id) {
				if (this.isLoad) {
					return
				}
				this.isLoad = !this.isLoad
				this.axios.delete('/admin/business.store/delete', {
					data: {
						ids: id
					}
				})
				.then(() => {
					this.isLoad = !this.isLoad
					this.$message.success({
						message: '冻结成功',
						showClose: false
					});
					this.loadList()
				})
				.catch(() => {
					this.isLoad = !this.isLoad
				})
			},
			jiedong(id) {
				if (this.isLoad) {
					return
				}
				this.isLoad = !this.isLoad
				this.axios.delete('/admin/business.store/jiedong', {
					data: {
						id: id
					}
				})
				.then(() => {
					this.isLoad = !this.isLoad
					this.$message.success({
						message: '解冻成功',
						showClose: false
					});
					this.loadList()
				})
				.catch(() => {
					this.isLoad = !this.isLoad
				})
			},
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},
			delAll() {
				let id = []
				for (let key in this.multipleSelection) {
					let item = this.multipleSelection[key]
					id.push(item.id)
				}
				if (this.isLoad)
					return
				this.isLoad = !this.isLoad
				this.axios.delete('/admin/business.store/delete', {
						data: {
							ids: id
						}
					}).then(() => {
						this.isLoad = !this.isLoad
						this.$message.success({
							message: '删除成功',
							showClose: false
						});
						this.loadList()
					})
					.catch(() => {
						this.isLoad = !this.isLoad
					})
			},

			sizeReload(val) {
				this.item.pageSize = val
				this.loadList()
			},
			pageReload(val) {
				this.item.page = val
				this.loadList()
			},
			// 搜索查询
			submit() {
				this.pageNum = 1
				this.item.page = 1
				this.loadList()
			},
			// 导出
			excelOut() {
				return;
				if (this.isLoad)
					return
				this.isLoad = !this.isLoad
				this.axios.get('/Member/excelOut', {
						params: {
							nickname: this.item.nickname,
							title: this.item.title
						}
					})
					.then(res => {
						this.isLoad = !this.isLoad
						// 导出
						window.open(res.url)
					})
					.catch(() => {
						this.isLoad = !this.isLoad
					})
			}
		}
	}
</script>
<style scoped>
</style>
